import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {
  @Output() onClose = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  closePrompt() {
    this.onClose.emit('close');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/user-info/user-info.component.ts